import React from "react";
import { IP } from "./../../../../internalServer";
// css comes in ReplyQuery.css

const NestedInput = ({ change, parentReply }) => {
  return (
    <>
      <div className=" p-2  gap-1 flex-wrap nested_input_group ">
        <div className="d-flex align-items-center justify-content-between">
          <div className=" gap-1 d-flex align-items-center">
            {parentReply?.user_id?.role === "Teacher" ? (
              <img
                src={
                  parentReply?.user_id?.profile_picture
                    ? IP +
                      parentReply?.user_id?.profile_picture.replace(/^\./, "")
                    : parentReply?.user_id?.gender === "M"
                    ? "/images/Teacher_Male.jpg"
                    : parentReply?.user_id?.gender === "F"
                    ? "/images/Teacher_Female.png"
                    : "/images/default-profile.png"
                }
                alt="icon"
                className="profilePicImg"
                style={{ width: "25px", height: "25px", borderRadius: "50%" }}
                onError={(e) => {
                  // This function will run if the image fails to load
                  if (parentReply?.user_id?.gender === "M") {
                    e.target.src = "/images/Teacher_Male.jpg";
                  } else if (parentReply?.user_id?.gender === "F") {
                    e.target.src = "/images/Teacher_Female.png";
                  } else {
                    e.target.src = "/images/default-profile.png";
                  }
                }}
              />
            ) : (
              <img
                src={
                  parentReply?.user_id?.profile_picture
                    ? IP +
                      parentReply?.user_id?.profile_picture.replace(/^\./, "")
                    : parentReply?.user_id?.gender === "M"
                    ? parentReply?.user_id?.avatarProfile
                      ? "/images/Boys/" +
                        parentReply?.user_id?.avatarProfile +
                        ".webp"
                      : "/images/Student_boy_pic.png"
                    : parentReply?.user_id?.gender === "F"
                    ? parentReply?.user_id?.avatarProfile
                      ? "/images/Girls/" +
                        parentReply?.user_id?.avatarProfile +
                        ".webp"
                      : "/images/Student_girl_pic.png"
                    : "/images/default image.png"
                }
                alt="icon"
                className="prifilePicImg"
                key={parentReply?.user_id?.avatarProfile}
                style={{ width: "25px", height: "25px", borderRadius: "50%" }}
                onError={(e) => {
                  if (parentReply?.user_id?.gender === "M") {
                    // console.log("insie if")
                    e.target.src = parentReply?.user_id?.avatarProfile
                      ? "/images/Boys/" +
                        parentReply?.user_id?.avatarProfile +
                        ".webp"
                      : "/images/Student_boy_pic.png";
                  } else if (parentReply?.user_id.gender === "F") {
                    e.target.src = parentReply?.user_id?.avatarProfile
                      ? "/images/Girls/" +
                        parentReply?.user_id?.avatarProfile +
                        ".webp"
                      : "/images/Student_girl_pic.png";
                  } else {
                    e.target.src = "/images/default image.png";
                  }
                }}
              />
            )}
            <span className=" nested_input_user_name">
              {parentReply.user_id.name}
            </span>
          </div>
          <img
            src="/images/cross-circle3.svg"
            className="nested_close_btn"
            alt=""
            onClick={() => change(false)}
          />
        </div>
        <p className="mb-0 mt-1 show_nested_input_contain">
          {parentReply.reply}
        </p>
      </div>
    </>
  );
};

export default NestedInput;
